import { render } from "./patient-invoices.vue?vue&type=template&id=31634ff2"
import script from "./patient-invoices.vue?vue&type=script&lang=js"
export * from "./patient-invoices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__